<template>
	<v-list-item two-line v-if="user">
		<v-list-item-avatar>
			<UserAvatar :user="user"></UserAvatar>
		</v-list-item-avatar>
		<v-list-item-content>
			<v-list-item-title link to="/profile" class="cn-font">{{user.display_name}}</v-list-item-title>
			<v-list-item-subtitle>
				Logged In
				<!-- <Logout></Logout> -->
			</v-list-item-subtitle>

		</v-list-item-content>
    </v-list-item>
</template>	
<script>
	// import Logout from "@/components/forms/Logout"
	import UserAvatar from "@/components/info/UserAvatar"
	import Vuex from "vuex"
	export default {
		name: "UserInfo",
		components: {
			UserAvatar,
			// Logout, 
		},
		computed: {
			...Vuex.mapState({
				user: state => state.auth.user
			})
		}
	}
</script>